export enum ROW_KIND {
  group = 'group',
  total = 'total',
  calculation = 'calculation',
  account = 'account',
  assumption = 'assumption',
  paymentType = 'paymentType',
  sheetsAssumption = 'sheetsAssumption',
  systemCalc = 'systemCalc',
  organisation = 'organisation-static',
  consolidation = 'consolidation-static',
  topLevel = 'top-level-static',
  heading = 'heading'
}

export enum ROW_ACCOUNT_TYPE {
  group = 'group',
  total = 'total',
  account = 'account',
  ai = 'AiAssumption',
  basic = 'BasicAssumption',
  formula = 'FormulaAssumption',
  units = 'UnitAssumption',
  repeating = 'RepeatingAssumption'
}

// Categories that need to pick up cumulative total of the previous month (not cumulative total of all months)
export const cumulativeTotalPreviousMonthCategories = [
  'fixed_assets',
  'current_assets',
  'non_current_assets',
  'current_liabilities',
  'non_current_liabilities'
];

// Static IDs that need FY values stored for joined row calculations
export const staticIdsForFYCalculations = [
  'income',
  'operating_profit',
  'net_profit',
  'other_income',
  'gross_profit'
];

export const rowKindsWithFYValue = [
  ROW_KIND.group,
  ROW_KIND.total,
  ROW_KIND.account,
  ROW_KIND.calculation,
  ROW_KIND.organisation
];
